var ua = navigator.userAgent;
var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
var iPad = ua.match(/(iPad).*OS\s([\d_]+)/);
var iPhone = !iPad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
var iOS = iPad || iPhone;
var model = ua.match(/(?:YuanSouTi|YuanTiKu|YuanFuDao|QQ|MicroMessenger|QQBrowser|MQQBrowser|MQQBrowserQQ|WeiBo|baiduboxapp|baidubrowser|SogouMobileBrowser|MiuiBrowser|UCBrowser|Maxthon|Kwai|NewsArticle)[^\/]*\/[\.0-9]+/g) || ua.match(/aweme_\d\.\d\.\d/);
var vendor = ua.match(/;([^/;]+)Build\//);
export var getAppVersion = function () {
    var UA_REGEX = /\s+(YuanTiKu|YuanFuDao|YuanSouTi|YuanSouTiKouSuan|Zebra YuanTiKu)\/(\d+\.\d+\.\d+)(\s+|$)/i;
    var matches = ua.match(UA_REGEX);
    return matches ? matches[2] : '';
};
export var isIOS = function () {
    return !!iOS;
};
export var isIPhone = function () {
    return !!iPhone;
};
export var isIPad = function () {
    return !!iPad;
};
export var isAndroid = function () {
    return !!android;
};
export var getOsVersion = function () {
    if (android) {
        return android[2];
    }
    if (iOS) {
        return iOS[2].replace(/_/g, '.');
    }
    return '';
};
export var getManufacturer = function () {
    if (vendor) {
        return vendor[1].trim();
    }
    return '';
};
export var getModel = function () {
    if (model) {
        return model.pop() || '';
    }
    return '';
};
export var getDevice = function () {
    if (isAndroid()) {
        return 2;
    }
    if (isIOS()) {
        return isIPad() ? 3 : 1;
    }
    return 5; // browser
};
